export default __webpack_public_path__ + "static/media/gallery-wip-neck_09.43467417.jpg";